module.exports = __webpack_public_path__ + "img/qr-code.ad909c85.png";